function replaceClass(classList, from, to) {
  classList.remove(from);
  classList.add(to);
}

function detectOrient() {
  const sw = window.screen.width;
  const sh = window.screen.height;
  const isIpad = Boolean(navigator.userAgent.match(/iPad/i)) || Boolean(navigator.userAgent.match(/Macintosh/i)) || navigator.userAgent.indexOf('YDUIStyle/PAD') > -1;
  if (isIpad || sw >= 768) {
    const docEl = document.documentElement;
    const cw = docEl.clientWidth;
    let width = 0;
    let height = 0;
    docEl.classList.add('ipad');
    let mode = '';
    // 2.在某些机型（如华为P9）下出现 srceen.width/height 值交换，所以进行大小值比较判断
    width = sw < sh ? sw : sh;
    height = sw >= sh ? sw : sh;
    if (cw === width) {
      replaceClass(docEl.classList, 'landscape', 'portrait');
      mode = 'portrait';
    }
    if (cw === height) {
      replaceClass(docEl.classList, 'portrait', 'landscape');
      mode = 'landscape';
    }
    return mode;
  }
  return null;
}
export default {
  detectOrient,
};
